import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EkubsComponent } from './ekubs.component';
import { EkubAddComponent } from './ekub.add.component';
import { AwardsComponent } from './awards.component';
import { AwardAddComponent } from './award.add.component';
import { EkubDetailComponent } from './ekub.detail.component';
import { AwardDetailComponent } from './award.detail.component';
import { CategoriesComponent } from './categories.component';
import { CoreService } from '../core/core.service';

const routes: Routes = [
  CoreService.childRoutes([
    { path: 'ekubs', component: EkubsComponent, data: { title: 'Ekubs' } },
    { path: 'ekubadd', component: EkubAddComponent, data: { title: 'Add Ekub' } },
    { path: 'awards', component: AwardsComponent, data: { title: 'Awards' } },
    { path: 'awardadd', component: AwardAddComponent, data: { title: 'Add Award' } },
    { path: 'ekub/:id', component: EkubDetailComponent, data: { title: 'Ekub Detail' } },
    { path: 'award/:id', component: AwardDetailComponent, data: { title: 'Award Detail' } },
    { path: 'categories', component: CategoriesComponent, data: { title: 'Categories' } },
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class EkubRoutingModule { }
